var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "position-relative mem_count_vue mr-2" },
    [
      _vm.is_load
        ? _c("b-spinner", {
            attrs: {
              small: "",
              label: "Small Spinner",
              variant: "danger",
              type: "grow",
            },
          })
        : _c("span", [
            _c("i", { staticClass: "fal fa-flag-alt" }),
            _vm._v(" "),
            _c("span", { staticClass: "badge badge-icon pos-top pos-right" }, [
              _vm._v(
                "\n                  " +
                  _vm._s(_vm.mem_anim_count) +
                  "\n            "
              ),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }